import TVNativeEventsDebugScreen from '@/components/TVNativeEventsDebugScreen';

export default function TVNativeEventsDebugRoute() {
  return <TVNativeEventsDebugScreen />;
}
